import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Subtract16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.5 7.25H13.5V8.75H2.5V7.25Z'
      fill='currentColor'
    />
  </Svg>
);

Subtract16.displayName = 'Subtract16';
export default Subtract16;
